import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { consume } from '@lit/context'
import {
  activeQuotationContext,
  awaitPendingQuotationUpdateContext,
  updateQuotationContext
} from 'components/ordering/quotation/components/context/quotation-context.js'
import { requestButtonStyles } from 'components/ordering/quotation/components/quotation.style.js'
import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'
import { customElement, state } from 'lit/decorators.js'
import { isQuotationDTO } from 'components/ordering/quotation/components/is-quotation-dto.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { UpdateQuotationPayload } from 'components/ordering/quotation/api/requests/update-quotation.js'

@customElement('csc-quotation-request-button')
export class CSCQuotationRequestButton extends LitElement {
  static override styles: CSSResultGroup = [requestButtonStyles]

  @consume({ context: activeQuotationContext, subscribe: true })
  private quotation!: QuotationDTO | NotFoundError

  @consume({ context: updateQuotationContext })
  private updateQuotation!: (payload: UpdateQuotationPayload) => Promise<void>

  @consume({ context: awaitPendingQuotationUpdateContext })
  private awaitPendingQuotationUpdate!: () => Promise<void>

  @state()
  private nameError = false

  async request(): Promise<void> {
    await this.awaitPendingQuotationUpdate()
    if (!isQuotationDTO(this.quotation)) return

    if (this.quotation.nameMandatory && !this.quotation.name) {
      this.nameError = true
      return
    }

    this.nameError = false
    await this.updateQuotation({
      quotationId: this.quotation.id,
      status: 'requested'
    })
  }

  override render() {
    if (!isQuotationDTO(this.quotation) || this.quotation.status !== 'open') {
      return nothing
    }
    return html`
      ${this.nameError ? html`<cse-alert variant="error">${t('quotation_request_name_required', { ns: 'csc-quotation-request-header', default: 'Quotation name is required' })}</cse-alert>` : nothing}
      <div class="actions">
        <cse-button
          class="bottom-buttons"
          variant="primary"
          fit="auto"
          @click=${this.request}
        >
          ${t('quotation_request_header_request_button', {
            ns: 'csc-quotation-request-header',
            default: 'Request quotation'
          })}
        </cse-button>
      </div>
    `
  }
}
